module.exports = __webpack_public_path__ + "static/download-image-b8b2609a4e1711098242689140d754e9.png";